import { useState } from 'react';

interface UsePaginationParams {
  initialPage?: number;
  pageSize?: number;
}

interface UsePaginationReturn {
  page: number;
  pageSize: number;
  totalPages: number;
  setPage: (page: number) => void;
  setTotalPages: (total: number) => void;
  resetToFirstPage: () => void;
  handlePageChange: (_event: React.ChangeEvent<unknown>, value: number) => void;
}

export function usePagination({ 
  initialPage = 0, 
  pageSize = 10 
}: UsePaginationParams = {}): UsePaginationReturn {
  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(0);

  const resetToFirstPage = () => setPage(0);

  const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value - 1); // MUI Pagination is 1-based, our API is 0-based
  };

  return {
    page,
    pageSize,
    totalPages,
    setPage,
    setTotalPages,
    resetToFirstPage,
    handlePageChange,
  };
}
